import { AxiosRequestConfig } from 'axios'

import { http } from './http'

export type FestivalModuleName =
  | 'MOBILE_APP'
  | 'LANGUAGES'
  | 'CURRENCY'
  | 'NOTIFICATIONS'
  | 'EMAILS'
  | 'USERS'
  | 'INFO'
  | 'NEWS'
  | 'SOCIAL_FEEDS'
  | 'VIDEO_GALLERY'
  | 'PHOTO_GALLERY'
  | 'ARTISTS'
  | 'STAGES'
  | 'MAP'
  | 'PARTNERS'
  | 'NEWSLETTER'
  | 'TICKETING'
  | 'TICKETING_SEATS'
  | 'TICKETING_CAMPAIGNS'
  | 'TICKETING_EXTERNAL_SELLER'
  | 'REFERRALS'
  | 'SEND_AS_GIFT'
  | 'INVITES'
  | 'PAY'
  | 'PAY_FIAT'
  | 'PAY_CRYPTO'
  | 'PAY_BNPL'
  | 'PAY_DIGITAL_WALLETS'
  | 'DELIVERY_SHIPPING'
  | 'INVOICING'
  | 'KYC'
  | 'TOPUP'
  | 'TOPUP_FESTIPAY'
  | 'MY_LINEUP'
  | 'PRE_MATCHMAKING'
  | 'FESTIVAL_FRIENDS'
  | 'CHECKIN'
  | 'MAP_LIVE'
  | 'GAMIFICATION'
  | 'MATCHMAKING'
  | 'CONNECT'
  | 'STAFF'
  | 'VENDORS'
  | 'SCAN_TICKETS'
  | 'ANALYTICS'

export interface FestivalModuleDependency {
  id: string
  name: FestivalModuleName
}

export interface FestivalModule {
  id: string
  name: FestivalModuleName
  enabled: boolean
  dependencies: FestivalModuleName[]
  dependsOnModels: FestivalModuleDependency[]
}

export interface FestivalModuleCategory {
  category: string
  modules: FestivalModule[]
}

export type ModuleSettingsPayload = Pick<
  FestivalModule,
  'id' | 'enabled' | 'name'
>

// Module endpoints are festival-scoped through the x-festival-name header.
const withFestivalName = (festivalName: string): AxiosRequestConfig => ({
  headers: { 'x-festival-name': festivalName },
})

export const getModuleSettings = (festivalName: string) =>
  http.get<FestivalModuleCategory[]>(
    '/operations/festivals/modules',
    withFestivalName(festivalName),
  )

export const updateModuleSettings = (
  festivalName: string,
  data: ModuleSettingsPayload[],
) =>
  http.put<FestivalModuleCategory[]>(
    '/operations/festivals/modules',
    data,
    withFestivalName(festivalName),
  )
